import { MovieShowFormat } from '@digilize/shared/definitions/src';

export interface MoviePhoto {
  id: string;
  url: string;
  title: string;
  alt: string;
}

export interface Show {
  id: string;
  title: string;
  photo: MoviePhoto;
  areaName: string;
  areaId: string;
  cinemaName: string;
  cinemaStreet: string;
  shopMenuUrl: string;
  shopId: string;
  startTime: Date;
  endTime: Date;
  disableAssignedSeating: boolean;
  is_cineville: boolean;
  shopName: string;
  /** Pipe-delimited PEGI + Kijkwijzer codes from `MovieShow.movie_pegis`, e.g. `"12|G|A|GT"`; null when unset. */
  pegis: string | null;
  /** The format the show plays in (PAUL-3131); null for a show from before formats, which reads as 2D. */
  format: MovieShowFormat | null;
}

/** The highest PEGI code at or above `minAge`, e.g. 18 for `"12|18"`; null when none qualifies. */
export function requiredAge(show: Show, minAge = 16): number | null {
  const codes = (show?.pegis ?? '')
    .split('|')
    .map(Number)
    .filter((code) => Number.isInteger(code) && code >= minAge);

  return codes.length > 0 ? Math.max(...codes) : null;
}

export function isAgeRestricted(show: Show, minAge = 16): boolean {
  return requiredAge(show, minAge) !== null;
}

/** Splits a pipe-delimited PEGI/Kijkwijzer string (e.g. `"12|G|A|GT"`) into its individual codes. */
export function pegiCodes(pegis: string | null | undefined): string[] {
  return (pegis ?? '').split('|').filter((code) => !!code);
}

const ageConfirmedKey = 'plys-ageConfirmed';

/** Whether the buyer confirmed their age in this browser session (tab) — any restricted show counts. */
export function hasConfirmedAge(): boolean {
  return sessionStorage.getItem(ageConfirmedKey) === 'true';
}

/** Only call after an actual confirmation — declining or dismissing the dialog must not set this. */
export function rememberAgeConfirmed(): void {
  sessionStorage.setItem(ageConfirmedKey, 'true');
}
